import * as React from 'react'

import { HeroRedesign } from 'sdk/sections/hero-redesign/HeroRedesign'
import sdkIcon from 'shared/assets/icons/sdk.svg'

import type { SdkHeroCmsContent } from 'core/services/cms/interfaces'

import sdkHeroBgLarge from '../../assets/sdk-hero-bg-large.jpg'
import sdkHeroBgSmall from '../../assets/sdk-hero-bg-small.jpg'
import sdkHeroBgXsm from '../../assets/sdk-hero-bg-xsm.jpg'

interface HeroProps {
  content: SdkHeroCmsContent
}

export const Hero: React.FC<HeroProps> = ({ content }) => {
  return (
    <HeroRedesign
      imageDesktop={sdkHeroBgLarge}
      imageTablet={sdkHeroBgSmall}
      imageMobile={sdkHeroBgXsm}
      pillText={content.pillText}
      pillIcon={sdkIcon}
      titleText={content.titleText}
      description={content.description}
    />
  )
}
